import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { ActivatedRoute } from '@angular/router';
import { RankingsService } from '../rankings/rankings.service';
import { Ranking } from '../rankings/ranking';
import { SeasonService } from '../season.service';
import { map, shareReplay } from 'rxjs/operators';

@Component({
  selector: 'mc-season-rankings',
  templateUrl: './season-rankings.component.html',
  styleUrls: ['./season-rankings.component.scss']
})
export class SeasonRankingsComponent implements OnInit {

  public readonly season$ = this.seasonService.activeSeason$;

  readonly rankings$: Observable<Ranking[]> = this.rankingsService.rankings$.pipe(
    map((rankings) => rankings.filter((ranking) => !ranking.excludeFromSeasonStandings)),
    shareReplay({
      refCount: true,
      bufferSize: 1
    })
  );

  constructor(
    private readonly activatedRoute: ActivatedRoute,
    private readonly seasonService: SeasonService,
    private readonly rankingsService: RankingsService
  ) { }

  relativeRouterPath(ranking: Ranking) {
    return [ranking.id, 'standings'];
  }

  ngOnInit() {

  }
}
